import { toApiResult } from "util/apiError";
import type { ApiResult } from "util/apiError";
import { plgRequest } from "plg/api/plgApi";
import type { PlgTokens } from "plg/auth/plgTokenStore";
import type { SetupProgress, SignupAnswers } from "plg/types";

// The setup steps after the account exists (the first step creates it: createPlgAccount).

/** Saved answers and whether setup is finished, to resume setup after a sign-in. */
export const fetchSetupProgress = async (): Promise<ApiResult<SetupProgress>> =>
  toApiResult<SetupProgress>(await plgRequest<SetupProgress>("GET", "/v1/plg/setup"));

/** Saves one step's answers in place of what that step had (409 SETUP_ALREADY_COMPLETE once setup is done). */
export const saveSetupStep = async (stepKey: string, answers: SignupAnswers): Promise<ApiResult<SetupProgress>> =>
  toApiResult<SetupProgress>(await plgRequest<SetupProgress>("PUT", `/v1/plg/setup/steps/${encodeURIComponent(stepKey)}`, { answers }));

/** Closes setup; the new session no longer sends the app back to setup. */
export const finishSetup = async (): Promise<ApiResult<PlgTokens>> =>
  toApiResult<PlgTokens>(await plgRequest<PlgTokens>("POST", "/v1/plg/setup/finish"));
